import {
  IInteractionTypes,
  interaction,
  navigation,
  task,
} from "@origin-digital/reporting-client";
import { APP_NAME } from "../consts";

export const LPG_FUEL = "lpg";

export enum TaskType {
  LPG_RESI_CALLBACK = "lpg-resi-call-back",
}

export enum ActionType {
  START = "start",
  COMPLETE = "complete",
}

export enum LPGForm {
  REQUEST_CALLBACK = "lpg-request-callback-form",
}

export enum SelfServiceActionType {
  RESI_CALLBACK = "lpg-resi-call-back",
}

export enum NavigationURIType {
  OFFERS = "originenergy:for-home:lpg:lpg-offers",
  REQUEST_CALLBACK = "originenergy:for-home:lpg:lpg-offers:callback",
  THANK_YOU = "originenergy:for-home:lpg:lpg-offers:callback:thank-you",
}

export const submitTaskAnalyticsEvent = (
  type: TaskType,
  action: ActionType,
  formName: string,
  selfServiceAction: string,
  state: string | undefined,
  postcode: string | undefined,
  productBody: any
) => {
  task.base(type, {
    appName: APP_NAME,
    action,
    formName,
    selfServiceAction,
    state,
    postcode,
    product: [productBody],
  });
};

export const submitInteractionEvent = (
  eventType: IInteractionTypes,
  componentType: string,
  id: string,
  appName: string,
  label: string
) => {
  interaction(eventType, {
    componentType,
    id,
    appName,
    label,
  });
};

export const submitNavigationEvent = (
  currentUri: string,
  friendlyUri: NavigationURIType
) => {
  navigation("screen", {
    appName: APP_NAME,
    currentUri,
    friendlyUri,
  });
};
